import { Grid, Typography } from "@mui/material";
import { Link } from "react-router-dom";

export const Ayuda = () => {
  return (
    <>
      <Grid container justifyContent="center">
        {" "}
        <Grid item xs={12} textAlign="center">
          {" "}
          <Typography variant="body1">
            ¿Necesitas ayuda para ingresar?
          </Typography>
        </Grid>
        <Grid item xs={3} textAlign="center">
          {" "}
          <Link
            to="/auth/preguntas-frecuentes"
            className="text-red-700 hover:underline"
          >
            Ver más detalles
          </Link>
        </Grid>
      </Grid>
    </>
  );
};
